import { useState, useEffect } from 'react';
import ScheduleEventsTemplate from './scheduleEventsTemplate';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import styles from '../../devotee.module.scss';
import toast from 'react-hot-toast';
import constants from "../../../../config/constants.json";
import { apiRequest, catchErrorMessageHandler, formatWeekday } from '../../../../infrastructure/backendService';
import ToastComponent from '../../../common/toastComponent';
import { Grid } from '@mui/material';
import ToastError from '../../../common/toast/toastError';
import { isNil } from 'lodash';
import apiPath from "../../../../config/apiPaths.json";
import ErrorPopup from '../../../common/ErrorPopup';
import { CustomCalendarIconForCalenderNext7Days } from '../../../common/StyledComponents/StyledFields';

interface TodayScheduleProps {
   date: Date;
   todayScheduleList: [] | string[]
   error: string | null
}

export default function TodayScheduleEvents(props: TodayScheduleProps): JSX.Element {
   // const [isOpen, setIsOpen] = useState<boolean>(false);
   // const [todayScheduleList, setTodayScheduleList] = useState<string[] | []>([]);
   // const [error, setError] = useState<string | null>(null);

   function formatDate(date: Date): string {
      const day = date?.getDate();
      const month = date?.getMonth() + 1;
      const year = date?.getFullYear();

      const formattedDay = day < 10 ? `0${day}` : day;
      const formattedMonth = month < 10 ? `0${month}` : month;

      return `${formattedMonth}/${formattedDay}/${year}`;
   }

   // useEffect(() => {
   //    apiRequest({
   //       method: 'POST',
   //       endpoint: apiPath.dailyTempleActivity,
   //       params: {
   //          scheduleDate: formatDate(props.date),
   //       }
   //    })
   //       .then((res) => {
   //          console.log(res.data);
   //          setTodayScheduleList(res.data.dailyActivities);
   //          setError(null); // Clear any previous errors
   //       })
   //       .catch((err) => {
   //          console.error(err);
   //          setError('Network error occurred'); // Set the error message
   //          toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
   //             duration: constants.TOAST_POPUP_DURATION,
   //           });
   //       });
   // }, [props.date]);

   

   const calenderDate = () => {
      return (
         <Box
            sx={{
               display: 'flex',
               flexDirection: 'row',
               marginBottom: '10px',
               padding: '10px 0px 0px 0px',
            }}
         >
            {CustomCalendarIconForCalenderNext7Days()}
            <Typography
               sx={{ fontSize: '16px', fontWeight: '600', marginLeft: '8px', fontStyle: 'normal' }}
            >
               {formatDate(props.date)} {formatWeekday(props.date)}
            </Typography>
         </Box>
      );
   };

   return (
      <Box className={styles.TotalConatiner}>
         <ToastComponent />
         {calenderDate()}
         {props.error ? (
            <div style={{ marginLeft: " 169px", marginTop: "80px" }}>
               <img src='/svg/loginError.svg' alt='Network Error' />
               <Typography
               sx={{position:"relative", right:"20px"}}
               >
                  Something went wrong.
               </Typography>
            </div>
         ) : (
            <ScheduleEventsTemplate itemList={props.todayScheduleList} />
         )}
      </Box>
   );
}
